<style scoped lang="scss">
@import "../../../common/styles/var";

i {
  width: 3px;
  height: 15px;
  background-color: $mainColor;
}
</style>

<template>
  <h3 class="fs18 flex aic">
    <i></i>
    <span class="ml10">{{ prefix }}{{ title }}</span>
    <slot></slot>
  </h3>
</template>

<script>
export default {
  name: "jijiu-page-title",
  props: {
    prefix: {
      type: String,
      default: '急重症转诊-'
    },
    title: {
      type: String,
      default: ''
    },
  },
}
</script>
